export interface DuesRatesRow {
  id: string;
  productName: string;
  classification: string;
  classificationDescription: string;
  rate_current_year: string | null;
  rate_previous_year: string | null;
  rate_previous_year_2: string | null;
  updatedAt: string | null;
  section: string | null;
  finalized: boolean;
  status: StatusType | null;
  statusMessage: string[];
}

export enum StatusType {
  WARNING = "warning",
  ERROR = "error"
}

export type Variables = {
  kind: string;
  classification?: string[];
  validation?: string[];
  search?: string;
  finalized?: boolean;
};
